import Vue from 'vue'
import Vuex from 'vuex'
import { studentLoginCheck, teacherLoginCheck } from "@/api/api2";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {}
  },
  getters: {
  },
  mutations: {
    studentLogin(state, result) {
      state.userInfo = result
    },
    teachLogin(state, result){
      state.userInfo = result
    },
    //退出登录
    loginOut(state){
      state.userInfo ={}
    }
  },
  actions: {
    //学生登录
    async getStudentLoginCheck({ commit }, params) {
      let stuLoginResult = await studentLoginCheck(params);
      // console.log(77,stuLoginResult);
      commit("studentLogin", stuLoginResult);
    },
    //老师登录
    async getTeacherLoginCheck({ commit }, params){
      let teaLoginResult = await teacherLoginCheck(params);
      commit("teachLogin", teaLoginResult);
    },
    
  },
  modules: {
  }
})
